import * as React from 'react';
import { FilterLineForEmailSubscriptionFilter } from 'flow-doctor-lib/utils/filterRenderUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import WalmartAbstractFilterRenderer from 'flow-doctor-lib/components/filters/WalmartAbstractFilterRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartEmailSubscriptionFilterRenderer = ({
  filter
}) => {
  return /*#__PURE__*/_jsx(WalmartAbstractFilterRenderer, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.filters.emailSubscription.label"
    }),
    filterLine: /*#__PURE__*/_jsx(FilterLineForEmailSubscriptionFilter, {
      filter: filter
    })
  });
};
export default WalmartEmailSubscriptionFilterRenderer;